import React from "react";
import {
  CheckboxInput,
  type CheckboxInputProps,
} from "src/shared/forms/inputs/CheckboxInputOld";

export type RadioInputProps = CheckboxInputProps;

export const RadioInput = (props: RadioInputProps) => {
  return <CheckboxInput {...props} type="radio" />;
};
